import axiosUtils from 'utils/axiosUtils';
import create from 'zustand';
import {
  editSmartOrder,
  getStockData,
  postSmartOrder,
  smartOrderDelete,
} from 'lib/api/smartOrder';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import SUCCESS_MESSAGE from 'constants/successMessage';
import {
  GetSmartOrderPayload,
  CreateSmartOrderPayload,
  EditSmartOrderPayload,
  DeleteSmartOrderPayload,
  GetSmartOrderResponse,
} from 'global/Securities/types/api/smartOrder';
import alertMessage from 'global/AlertMessage';

interface IAutoOrderStore {
  stockData: GetSmartOrderResponse;
  isLoading: boolean;
  resetStockData: () => void;
  getStockData: (payload: GetSmartOrderPayload) => void;
  addSmartOrder: (payload: CreateSmartOrderPayload, type: string) => any;
  deleteSmartOrder: (payload: DeleteSmartOrderPayload, type: string) => any;
  editSmartOrder: (payload: EditSmartOrderPayload, type: string) => any;
}

const showErrorMessage = (err: Error) => {
  if (!axiosUtils.isAxiosError(err)) {
    alertMessage({
      content: err.message,
      alertType: 'plain-default',
      messageType: 'error',
      hasCloseIcon: false,
    });
  }
};

const autoOrderStore = create<IAutoOrderStore>((set) => ({
  stockData: [],
  isLoading: false,
  resetStockData: async () => {
    set({ stockData: [] });
  },
  getStockData: async (payload) => {
    try {
      set({ isLoading: true });
      const response = await getStockData(payload);
      if (!response?.data) {
        throw new Error('Error while fetching data');
      }

      const { data } = response.data;
      set({ stockData: data });
    } catch (err) {
      if (!axiosUtils.isAxiosError(err)) {
        showErrorMessage(err);
      }
    } finally {
      set({ isLoading: false });
    }
  },
  addSmartOrder: async (payload, type) => {
    try {
      set({ isLoading: true });
      const response = await postSmartOrder(payload);
      if (!response?.data) {
        throw new Error('Error while fetching data');
      }

      handleErrorMessageAPI(
        `${type} berhasil dipasang`,
        SUCCESS_MESSAGE.ALERT_GREEN,
      );
    } catch (err) {
      if (!axiosUtils.isAxiosError(err)) {
        showErrorMessage(err);
      }
    } finally {
      set({ isLoading: false });
    }
  },
  deleteSmartOrder: async (payload, type) => {
    try {
      set({ isLoading: true });
      const response = await smartOrderDelete(payload);
      if (!response?.data) {
        throw new Error('Error while fetching data');
      }

      handleErrorMessageAPI(
        `${type} berhasil dihapus`,
        SUCCESS_MESSAGE.ALERT_GREEN,
      );
    } catch (err) {
      showErrorMessage(err);
    } finally {
      set({ isLoading: false });
    }
  },
  editSmartOrder: async (payload, type) => {
    try {
      set({ isLoading: true });
      const response = await editSmartOrder(payload);
      if (!response?.data) {
        throw new Error('Error while fetching data');
      }

      handleErrorMessageAPI(
        `${type} berhasil diubah`,
        SUCCESS_MESSAGE.ALERT_GREEN,
      );
    } catch (err) {
      if (!axiosUtils.isAxiosError(err)) {
        showErrorMessage(err);
      }
    } finally {
      set({ isLoading: false });
    }
  },
}));

export default autoOrderStore;
